import { getCookie, setCookie } from './cookies';

export const ALGOLIA_USER_TOKEN_COOKIE = 'suserid';

// Created client-side rather than in the proxy: Akamai doesn't store Set-Cookie, so visitors whose
// first pages are served from the edge cache would otherwise never receive one (CECM-41513).
export function getAlgoliaUserToken(): string {
    const existing = getCookie(ALGOLIA_USER_TOKEN_COOKIE);

    if (existing) {
        return existing;
    }

    const token = crypto.randomUUID();
    setCookie(ALGOLIA_USER_TOKEN_COOKIE, token);

    return token;
}
